<template>
<!--  1px is a trick so the element gets a height which can be inherited. -->
  <div>
    <div style="display: flex">
      <div class="filterContainer"  v-if="$q.screen.width >= 768">
        <product-filters></product-filters>
      </div>
      <div style="flex: 1; background-color: #f5f5f5">
        <div class="bg-black text-white text-center">
          <div style="width:100%; margin: 0 auto; padding: 4px 0; font-weight: 300;" >Corporate Factory Store</div>
        </div>
        <product-category-filter v-if="$q.screen.width >= 980"/>
        <div class="column calculatedContentAreaForContainerStores">
          <!-- Container status message -->
           <!-- Row with Sort, Count, and Pagination if resultCount > 0  -->
           <div style="display: flex; justify-content: center; margin-top: 4px; padding: 0 5px; height: 40px;" >
            <div style="display: flex; max-width: 1000px; width:100%; justify-content: space-between;" v-if="resultCount > 0">
              <div v-if="$q.screen.width < 768">
                <q-btn color="primary" dense outline icon="filter_alt" @click="showFilter = true" style="height: 100%;"/>
              </div>
              <div>
                <q-select v-model="orderBy" :options="orderByOptions" class="q-mr-lg" style="min-width:120px; display: inline-block;" dense outlined bg-color="white" label="Sort by"/>
              </div>
              <div class="text-bold" style="margin: auto 0; font-size: 18px;">
                  {{resultCount}} Items
              </div>
              <div v-if="maxPage > 1">
                <q-select dense v-model="currentPage" :options="paginationOptions" outlined v-if="$q.screen.width <= 900" bg-color="white"/>
                <div style="margin: 5px 0 0 0">
                  <q-pagination size="14px" v-model="currentPage" :max="maxPage" direction-links :max-pages="5" v-if="$q.screen.width > 900" />
                </div>
              </div>
            </div>
          </div>
          <!-- Row with No Items if resultCount == 0 -->
          <div class="text-h4" style="display: flex; justify-content: center; margin-top:30px" v-if="resultCount == 0">
            <p>No items found!</p>
          </div>

          <!-- Row with Products if resultCount > 0  -->
          <q-scroll-area class="col" ref="scrollAreaRef">
          <!-- <div class="col"> -->
            <div class="text-center" style="margin: 4px 1rem">

                <a href="https://my.climbicp.com.au/container/grid?filters=W3sidHlwZSI6ImJyYW5kIiwidmFsdWVzIjpbIjM2MCIsIkFudGkgR3Jhdml0eSIsIkFyY3RpYyBHcmlwIiwiR3JpenpseSIsIk5leHQiLCJTaW1wbCIsIlRyaWNraXQiXX1d"><img src="../../../src/assets/discount_banner.png" width="100%" style="max-width:1080px"/></a>

            </div>
            <div class="text-black text-center" style="margin: 0; padding: 0;">
              <div v-if="!$apollo.queries.activeGroupOrder.loading">
                <q-banner v-if="activeGroupOrder" style="margin: 0; padding: 0;">
                  <span style="font-size:1.5em; font-weight: 600;">{{activeGroupOrder.name}} is open
                    <span v-if="orderClosingSoon">- closes <u>{{fromNow(activeGroupOrder.closeDate)}}</u>
                    <q-tooltip>Closes {{formatDateTime(activeGroupOrder.closeDate)}}</q-tooltip></span>
                    <span v-else>. Closing soon!</span>
                  </span>
                </q-banner>
                <q-banner  v-else>
                  <span style="font-size:1.5em">There is currently no container open for orders.</span>
                </q-banner>
              </div>
            </div>
            <div class="row" v-if="resultCount">
              <div class="col">
                <router-view :products="products" storeType="container" :productCount="resultCount"></router-view>
                <div style="display: flex; justify-content: center; margin-top: 10px; padding: 0 5px; height: 40px;" >
                  <div style="display: flex; max-width: 1000px; width:100%; justify-content: end;" v-if="maxPage > 1">
                    <q-select dense v-model="currentPage" :options="paginationOptions" outlined v-if="$q.screen.width <= 900" bg-color="white" label="Page" style="width: 80px;"/>
                    <div style="margin: 5px 0 0 0">
                      <q-pagination size="14px" v-model="currentPage" :max="maxPage" direction-links :max-pages="5" v-if="$q.screen.width > 900" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          <!-- </div> -->
          </q-scroll-area>
        </div>
        <product-dialog storeType="container"></product-dialog>
      </div>
    </div>

  <!-- Dialog on small screens show filter -->
  <q-dialog v-model="showFilter" position="left" full-height>
    <product-filters></product-filters>
  </q-dialog>

  </div>
</template>

<script>
import ProductDialog from '../../components/ProductDialog'
import ProductCategoryFilter from '../../components/ProductCategoryFilter'
import ProductFilters from '../../components/ProductFilters'
import gql from 'graphql-tag'
import { mapGetters } from 'vuex'
import EditCartMenu from '../../components/EditCartMenu'
import { formatCurrency, formatDateTime } from '../../util/string'
import moment from 'moment'

export default {
  name: 'PageStockProduct',
  components: {
    EditCartMenu,
    ProductDialog,
    ProductCategoryFilter,
    ProductFilters
  },
  apollo: {
    activeGroupOrder () {
      return {
        query: gql`
          query {
            activeGroupOrder {
              id
              name
              openDate
              closeDate
            }
          }
        `
      }
    },
    products () {
      return {
        query: gql`
          query products ($filter: ProductFilterInput, $limit: Int, $offset: Int, $orderBy: ProductsOrderByFieldInput, $descending: SortOrderInput) {
            products(filter: $filter, store: Container, limit: $limit, offset: $offset, orderBy: $orderBy, descending: $descending) {
              products {
                id,
                name,
                reference,
                attributes,
                images {
                  url
                  name
                },
                urlSlug,
                description,
                skus {
                  id,
                  showInContainer,
                  containerPrice,
                  options,
                  stock,
                  previousStock,
                  stockLastUpdate,
                  createdAt,
                  updatedAt
                },
                createdAt,
                updatedAt
              }
              count
            }
          }
        `,
        skip: () => !this.currentAccount,
        variables () {
          return {
            filter: this.productFilterGql,
            limit: this.pageSize,
            offset: (this.currentPage - 1) * this.pageSize,
            orderBy: this.orderBy?.toLowerCase(),
            descending: 'Ascending'
          }
        },
        update (result) {
          this.trk_products_loaded(result.products.products.length, result.products.count)
          this.resultCount = result.products.count
          return result.products.products
        },
        fetchPolicy: 'network-only',
        result (result) {
          this.$refs.scrollAreaRef.setScrollPosition('vertical', 0)
          this.maxPage = Math.ceil(result.data.products.count / this.pageSize)
        }
      }
    },
    activeCart () {
      return {
        query: gql`
          query activeCart ($id: ID!) {
            cart(id: $id) {
              id,
              name
              items {
                id,
                skuId,
                qty,
                sku {
                  id,
                  options,
                  containerPrice,
                  product {
                      id,
                      attributes
                  }
                }
              }
            }
          }
        `,
        variables () {
          return {
            id: this.activeContainerCartId
          }
        },
        update: data => data.cart,
        skip: () => !this.currentAccount,
        error (error) {
          if (error.message === `GraphQL error: Cart with id ${this.activeContainerCartId} does not exist.`) {
            return this.$store.dispatch('cart/createNewActiveCart', { input: { name: `Factory Cart ${moment().format('DD/MM/YY')}` }, storeType: 'container' })
          }
        }
      }
    }
  },
  watch: {
    productFilterGql (a, b) {
      this.currentPage = 1
    },
    orderBy () {
      this.currentPage = 1
    }
  },
  computed: {
    ...mapGetters('filters', ['productFilterGql']),
    displayType () {
      return this.$route.path.split('/').slice(-1)[0]
    },
    currentAccount () {
      return this.$store.state.auth.currentAccount
    },
    activeContainerCartId () {
      return this.currentAccount?.activeContainerCartId
    },
    totalHolds () {
      return this.activeCart?.items?.reduce((p, c, i) => p + ((c.sku?.product?.attributes?.holds || 0) * Number(c.qty)), 0)
    },
    totalSets () {
      return this.activeCart?.items?.reduce((p, c, i) => p + Number(c.qty), 0)
    },
    totalCost () {
      return this.activeCart?.items?.reduce((p, c, i) => p + ((c.sku?.containerPrice || 0) * Number(c.qty)), 0)
    },
    orderClosingSoon () {
      return moment(this.activeGroupOrder.closeDate).isAfter(moment())
    },
    paginationOptions () {
      return Array.from({ length: this.maxPage }, (v, k) => k + 1)
    }
  },
  methods: {
    trk_display_type (selection) {
      analytics.track('Product Display Type', {
        type: selection,
        storeType: this.$store.state.cart.currentStoreType
      })
    },
    trk_products_loaded (loadedQty, totalProducts) {
      analytics.track('Products Loaded', {
        loaded: loadedQty,
        total: totalProducts,
        secondsBetweenLoads: (Date.now() - this.loadedAt) / 1000,
        storeType: this.$store.state.cart.currentStoreType
      })
      // Reset date
      this.loadedAt = Date.now()
    },
    formatDateTime: formatDateTime,
    fromNow (t) {
      if (!t) return '-'
      return moment(t).fromNow()
    },
    async fetchMore (done) {
      try {
        await this.$apollo.queries.products.fetchMore({
          variables: {
            offset: this.products.length
          },
          updateQuery: (previousQueryResult, { fetchMoreResult }) => {
            if (!previousQueryResult) {
              this.$apollo.queries.products.refetch()
              done()
              return null
            }
            if (!fetchMoreResult.products?.products?.length) {
              done(true)
              return previousQueryResult
            }
            done()
            return Object.assign({}, previousQueryResult, {
              products: {
                __typename: previousQueryResult.products.__typename,
                products: [...previousQueryResult.products.products, ...fetchMoreResult.products.products],
                count: previousQueryResult.products.count
              }
            })
          }
        })
      } catch (error) {
        done()
        this.$nextTick(() => {
          this.$apollo.queries.products.refetch()
        })
      }
    },
    formatCurrency: formatCurrency,
    setDisplayType (displayType) {
      this.$router.push(`/container/${displayType}`)
    }
  },
  data () {
    return {
      currentPage: 1,
      maxPage: 1,
      pageSize: 24,
      products: [],
      resultCount: 0,
      orderBy: 'Price',
      orderByOptions: ['Brand', 'Range', 'Name', 'Price', 'Newest'],
      thumbStyle: {
        right: '2px',
        borderRadius: '5px',
        backgroundColor: '#c5161c',
        width: '7px',
        opacity: 0.75
      },
      loadedAt: Date.now(),
      showFilter: false
    }
  }
}
</script>

<style scoped lang="stylus">
  @import '~quasar-variables'
  .q-banner{
    .medium-text {
      font-size 40px;
      @media (max-width $breakpoint-sm) {
        font-size 20px;
      }
    }
  }
</style>

<style >
  .filterContainer {
    width: 220px;
    background-color: white;
    border-right: 1px solid rgba(0, 0, 0, 0.05);
  }

  .calculatedContentAreaForContainerStores{
    @media (max-width: 8000px) {
      height: calc(100vh - 227px);
    }

    @media (max-width: 978px) {
      height: calc(100vh - 156px);
    }

    @media (max-width: 919px) {
      height: calc(100vh - 92px);

    }

    @media (max-width: 768px) {
      height: calc(100vh - 92px);
    }


    @media (max-width: 600px) {
      height: calc(100vh - 139px);
    }
  }

</style>
